import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

// Core authenticated pages (loaded eagerly — primary app surface)
import MainPage from '../MainPage';
import ReplayPage from '../reports/ReplayPage';
import SharePage from '../share/SharePage';
import ShareReservationPage from '../share/ShareReservationPage';
import TemporaryVerificationPage from '../TemporaryVerificationPage';
import PositionPage from '../PositionPage';
import DevicePage from '../DevicePage';
import OemDevicePage from '../OemDevicePage';
import GeofencePage from '../GeofencePage';
import GeofencesPage from '../GeofencesPage';
import LinkPage from '../LinkPage';
import UserPage from '../UserPage';
import SmartcarDevicePage from '../SmartcarDevicePage';
import TeslaDeviceListPage from '../TeslaDeviceListPage';
import TollListSite from '../TollListSite';
import ProfilePage from '../ProfilePage';
import TeslaTestSite from '../TeslaTestSite';
import TestSite1 from '../TestSite1';
import SmartcarV3DevicePage from '../SmartcarV3DevicePage';

// Settings — lazy
const LinksDataTablePage = lazy(() => import('../settings/LinksDataTablePage'));
const CoHostDataTablePage = lazy(() => import('../settings/CoHostDataTablePage'));
const ShuttlePage = lazy(() => import('../settings/ShuttlePage'));
const TimerPage = lazy(() => import('../settings/TimerPage'));
const UserBlogPage = lazy(() => import('../settings/UserBlogPage'));
const TuroTripsPage = lazy(() => import('../settings/TuroTripsPage'));
const TuroLoginsPage = lazy(() => import('../settings/TuroLoginsPage'));
const PushNotificationDataTablePage = lazy(() => import('../settings/PushNotificationDataTablePage'));
const CreditCardListPage = lazy(() => import('../settings/CreditCardListPage'));
const BatteryDataTablePage = lazy(() => import('../settings/BatteryDataTablePage'));

// Reports — lazy
const CommandsPage = lazy(() => import('../reports/CommandsPage'));
const EventReportPage = lazy(() => import('../reports/EventReportPage'));
const DailyMileageReportPage = lazy(() => import('../reports/DailyMileageReportPage'));

export const authorizedRoutes = [
  <Route key="main" exact path="/main" component={MainPage} />,
  <Route key="replay" exact path="/replay/:id?" component={ReplayPage} />,
  <Route key="share" exact path="/share/:id?" component={SharePage} />,
  <Route key="share-reservation" exact path="/share-reservation/:id?" component={ShareReservationPage} />,
  <Route key="temporary-verification" exact path="/temporary-verification/:shareUrl" component={TemporaryVerificationPage} />,
  // <Route key="position" exact path="/position/:id?" component={PositionPage} />,
  <Route key="device" exact path="/device/:id?" component={DevicePage} />,
  <Route key="oem-device" exact path="/oem-device/:id?" component={OemDevicePage} />,

  <Route key="geofence" exact path="/geofence/:id?" component={GeofencePage} />,
  <Route key="geofences" exact path="/geofences/:id?" component={GeofencesPage} />,
  <Route key="settings-links" exact path="/settings/links" component={LinksDataTablePage} />,
  <Route key="settings-co-host" exact path="/settings/co-host" component={CoHostDataTablePage} />,
  <Route key="settings-shuttle" exact path="/settings/shuttle" component={ShuttlePage} />,
  <Route key="settings-timer" exact path="/settings/timer" component={TimerPage} />,
  <Route key="settings-user-blog" exact path="/settings/user-blog" component={UserBlogPage} />,
  <Route key="settings-turo-trips" exact path="/settings/turo-trips" component={TuroTripsPage} />,
  <Route key="settings-turo-logins" exact path="/settings/turo-logins" component={TuroLoginsPage} />,
  <Route key="settings-push-notifications" exact path="/settings/push-notifications" component={PushNotificationDataTablePage} />,
  <Route key="settings-credit-cards" exact path="/settings/credit-cards" component={CreditCardListPage} />,
  <Route key="settings-battery" exact path="/settings/battery" component={BatteryDataTablePage} />,

  <Route key="link" exact path="/link/:id?" component={LinkPage} />,
  <Route key="escrow-logs" exact path="/escrow-logs" component={UserPage} />,
  <Route key="smartcar-device" exact path="/smartcar-device/:id?" component={SmartcarDevicePage} />,
  <Route key="smartcar-v3-device" exact path="/smartcar-v3-device/:id?" component={SmartcarV3DevicePage} />,
  <Route key="tesla-device" exact path="/tesla-device/:id?" component={TeslaDeviceListPage} />,

  <Route key="toll-list" exact path="/toll-list/:searchId" component={TollListSite} />,
  <Route key="reports-commands" exact path="/reports/commands/:id?" component={CommandsPage} />,
  <Route key="reports-event" exact path="/reports/event/:id?" component={EventReportPage} />,
  <Route key="reports-daily-mileage" exact path="/reports/daily-mileage/:id?" component={DailyMileageReportPage} />,
  <Route key="reports-chart" exact path="/reports/chart" component={TestSite1} />,

  <Route key="profile" exact path="/profile" component={ProfilePage} />,
  <Route key="user" exact path="/user/:id?" component={UserPage} />,

  <Route key="tesla-test" exact path="/tesla-test" component={TeslaTestSite} />,
];
